import { useEffect, useMemo, useState } from 'react'

import { useNotifications } from 'app/application/application'
import { useApi } from 'app/common/application'
import { Signal } from 'app/signals/types'

interface ModelSummary {
  id: string
  path: string
  type: 'causal' | 'conversion'
  created: string
  f1Score?: number
  scope?: 'campaign' | 'treatment'
}

const useSignalModels = (signals: Signal[]) => {
  const { create } = useApi()
  const { createNotification, te } = useNotifications()
  const [models, setModels] = useState<ModelSummary[]>([])
  const ids = useMemo(
    () => [...new Set(signals.flatMap(({ model }) => (model ? [model] : [])))],
    [signals],
  )

  useEffect(() => {
    let active = true
    setModels([])
    if (ids.length === 0) return

    void create<{ content: { id: string[] } }, { data: ModelSummary[] }>('/models/query', {
      content: { id: ids },
    }).then((result) => {
      if (!active) return
      if (result.ok) setModels(result.val.data)
      else {
        createNotification({
          title: te(`http.${result.val.code}`),
          message: result.val.message,
          type: 'error',
        })
      }
    })

    return () => {
      active = false
    }
  }, [create, createNotification, ids, te])

  return useMemo(() => new Map(models.map((model) => [model.id, model])), [models])
}

export default useSignalModels
